// Application Configuration
const config = {
  // API Configuration
  // QA_URL : 'https://qa.testmything.online',
  api: {
    // baseURL:'https://qa.elevated.totalhealthandfitness.com/api',
    // baseURL: 'https://qa.testmything.online/api',
    // baseURL: 'https://api.elevated.totalhealthandfitness.com',
    // Same-origin path: proxied to http://ec2-77-113-52-197.us-east-2.compute.amazonaws.com/api by public/_redirects (Netlify) and vite.config.js (dev)
    baseURL: '/api',
    timeout: 30000, // 30 seconds
    endpoints: {
      // Authentication endpoints
      fetchUserCompanies: '/fetchusercompanies',
      auth: '/auth',
      googleAuth: '/auth/gmail',
      
      // Dashboard endpoints
      sideMenu: '/dashboard/sidemenu', // Will be prefixed with company_url
      companyDetails: '/companyadmin/getmycompanydetails', // Will be prefixed with company_url
      
      // Add other endpoints as needed
      // users: '/users',
      // workouts: '/workouts',
      
      // Nutrition endpoints
      getClientPrograms: '/getclientprograms',
      clientNutrition: '/clientnutrition',
      staticPages: '/staticpages',
      deleteLogNutritionFood: '/deletelognutrisinglefood',
      shoppingListPdf: (programId, clientId) => `/getshoppinglistpdf/${clientId}/${programId}`,
      mealsPdf: (programId, clientId) => `/getmealspdf/${clientId}/${programId}`,
      nutritionSearch: '/nutrition/search',
      nutritionSearchByScan: '/nutrition/searchbyscan',
      nutritionNutrients: '/nutrition/nutrients',
      createLogNutritionFood: '/createlognutritionsinglefoodv2',
      updateLogNutritionFood: '/update/lognutritionsinglefoods',
      recipePdf: (programId) => `/getrecipepdf/${programId}`,
      exercisesPdf: (clientId, sessionId) => `/getexercisespdf/${clientId}/${sessionId}`,

      // Signup endpoints
      checkEmailAvailability: '/signup/check-email',
      signup: '/signup',
      checkCompanyUrl: '/signup/check-company-url'
    }
  },

  // Application settings
  app: {
    name: 'HealthyCoach',
    version: '1.0.0',
    environment: process.env.NODE_ENV || 'development',
  },

  oauth: {
    googleClientId: '1086453462813-q3c3dkinn2g79g15clqkvivn27srke92.apps.googleusercontent.com'
  },

  // Storage keys
  storage: {
    authToken: 'neat_fit_auth_token',
    refreshToken: 'neat_fit_refresh_token',
    userData: 'neat_fit_user_data',
    companyData: 'neat_fit_company_data',
    sideMenuData: 'neat_fit_side_menu_data',
    companyDetailsData: 'neat_fit_company_details_data',
  },

  // Media hosting (exercise template images are stored as bucket keys)
  media: {
    exerciseImageBaseUrl: 'https://thfmedia.s3.us-east-2.amazonaws.com/',
  },

  // UI Configuration
  ui: {
    defaultTheme: 'light',
    // Colours of page headers / hero banners:
    //   'default' – fixed header colours (defined once in index.css as --header-*), ignoring the company brand colour
    //   'brand'   – headers follow the company's primary colour (falls back to 'default' when the company has none)
    headerTheme: 'default',
    animationDuration: 300,
    toastDuration: 5000,
  },

  // Validation rules
  validation: {
    email: {
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: 'Please enter a valid email address'
    },
    password: {
      minLength: 6,
      message: 'Password must be at least 6 characters long'
    }
  }
}

export default config
